import { render, staticRenderFns } from "./CheckboxButton.vue?vue&type=template&id=03567b08&scoped=true&"
import script from "./CheckboxButton.vue?vue&type=script&lang=js&"
export * from "./CheckboxButton.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxButton.vue?vue&type=style&index=0&id=03567b08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03567b08",
  null
  
)

export default component.exports